angular.module('ngDragDrop', []);
angular.module('trainerWebApp.consts', []).value('trainerWebApp.consts', {});
angular.module('trainerWebApp.resources', ['ngResource']);
angular.module('trainerWebApp.services', ['ngResource']);
angular.module('trainerWebApp.directives', ['trainerWebApp.consts']);
angular.module('trainerWebApp.modals', []);
angular.module('trainerWebApp.course', []);
angular.module('trainerWebApp.popovers', ['trainerWebApp.resources']);
angular.module('trainerWebApp.main', ['trainerWebApp.services']);
angular.module('trainerWebApp.controllers', ['trainerWebApp.resources', 'trainerWebApp.services']);

angular.module('trainerWebApp', [
  'ngSanitize',
  'ngRoute',
  '$strap',
  'ui',
  'ui.bootstrap',
  'ui.sortable',
  'ngDragDrop',
  'branding',
  'ngMessages',
  'trainerWebApp.consts',
  'trainerWebApp.resources',
  'trainerWebApp.services',
  'trainerWebApp.directives',
  'trainerWebApp.modals',
  'trainerWebApp.popovers',
  'trainerWebApp.controllers',
  'trainerWebApp.course',
  'trainerWebApp.main']);

angular.module('trainerWebApp').config(['$routeProvider', '$locationProvider', '$httpProvider', 'mtypes', '$compileProvider', function ($routeProvider, $locationProvider, $httpProvider, mtypes, $compileProvider) {
  $httpProvider.defaults.headers.common['x-mf-sess'] = mfConfig.sessionId;
  $httpProvider.defaults.headers['delete'] = {'Content-Type': 'application/json'};

  //^\s*(https?|ftp|file):|data:image\//
  $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|file):|data:/);

  function newResolver(name) {
    var ret = function (fn) {
      return fn();
    };
    ret.$inject = [name];
    return ret;
  }

  var seriesResolver = newResolver('SeriesCtrlResolver');
  var courseResolver = newResolver('CourseCtrlResolver');
  var usersResolver = newResolver('UsersCtrlResolver');
  var groupsResolver = newResolver('GroupsCtrlResolver');
  var customFieldsResolver = newResolver('CustomFieldsCtrlResolver');
  var homeCtrlResolver = newResolver('HomeCtrlResolver');
  var catalogResolver = newResolver('CatalogResolver');
  var shopifyResolver = newResolver('ShopifyResolver');
  var brandResolver = newResolver('brandResolver');
  var createGroupResolver = newResolver('CreateGroupCtrlResolver');
  var defaultResolver = newResolver('DefaultResolver');
  var customCertificateResolver = newResolver('CustomCertificateResolver');
  var featuresResolver = newResolver('FeaturesResolver');

  // check to see if user is logged in
  if (!mfConfig.sessionId) return;

  function hasFeature(feature) {
    return ~mfConfig.features.indexOf(feature) || ~mfConfig.trialFeatures.indexOf(feature);
  }

  // hack to to hide footer and header when montara
  var showFrame = undefined;
  if(hasFeature(mtypes.featureEntry.leftMenuMontara)) {
    showFrame = false;
  }

  if (hasFeature(mtypes.featureEntry.trainerHTMLHome))
    $routeProvider.when('/TMS/Home', {templateUrl: 'pages/home/home.html', controller: 'HomeCtrl', pageName: 'home', header: showFrame, footer: showFrame, resolve: {resolveData: homeCtrlResolver}});


  $routeProvider
    .when('/accountInfo', {templateUrl: 'pages/accountInfo/accountInfo.html', controller: 'AccountInfoCtrl' })
    .when('/Home', {templateUrl: 'pages/home/home.html', controller: 'HomeCtrl', pageName: 'home', header: showFrame, footer: showFrame, resolve: {resolveData: homeCtrlResolver}})
    .when('/TMS/Series/:seriesId', {templateUrl: 'pages/series/series.html', controller: 'SeriesCtrl', pageName: 'series', resolve: {resolveData: seriesResolver}})
    .when('/TMS/Series/:seriesId/customCertificate', {templateUrl: 'pages/certificate/customCertificate.html', pageName: 'customCertificate', controller: 'CustomCertificateCtrl', resolve: {resolveData: customCertificateResolver}})
    .when('/TMS/Series/:seriesId/:tabName', {templateUrl: 'pages/series/series.html', controller: 'SeriesCtrl', reloadOnSearch: false, pageName: 'series', resolve: {resolveData: seriesResolver}})

    .when('/TMS/Distribute_Course/:courseId/addNewUser', {templateUrl: 'pages/users/addNewUser.html', controller: 'AddNewUserToCourseCtrl', pageName: 'addNewUser', resolve: {resolveData: courseResolver}})
    .when('/TMS/Distribute_Course/:courseId/trainees', {templateUrl: 'pages/course/courseTrainees.html', controller: 'CourseTraineesCtrl', pageName: 'trainees', resolve: {resolveData: courseResolver}})
    .when('/TMS/Distribute_Course/:courseId/emails', {templateUrl: 'pages/course/courseEmails.html', controller: 'CourseEmailsCtrl', pageName: 'courseEmails', resolve: {resolveData: courseResolver}})

    .when('/TMS/Distribute_Course/:courseId/addExistingTrainees', {templateUrl: 'pages/users/inviteTrainees.html', controller: 'AccountForCourseCtrl', pageName: 'addExistingTrainees', resolve: {resolveData: courseResolver}})
    .when('/TMS/Distribute_Course/:courseId/addYammerUsers', {templateUrl: 'pages/yammer/yammerTrainees.html', controller: 'AddYammerUsersCtrl', pageName: 'addYammerUsers', resolve: {resolveData: courseResolver}})
    .when('/TMS/Distribute_Course/:courseId/importXls', {templateUrl: 'pages/users/xls/xls.html', pageName: 'importXls', reloadOnSearch: false, resolve: {resolveData: courseResolver}})
    .when('/TMS/Customize_Settings/:courseId/customCertificate', {templateUrl: 'pages/certificate/customCertificate.html', pageName: 'customCertificate', controller: 'CustomCertificateCtrl', resolve: {resolveData: customCertificateResolver}})


    .when('/TMS/ManageUsers/addNewUser', {templateUrl: 'pages/users/addNewUser.html', controller: 'AddNewUserToManageCtrl', pageName: 'addNewUser', resolve: {resolveData: usersResolver}})
    .when('/TMS/ManageUsers/addYammerUsers', {templateUrl: 'pages/yammer/yammerTrainees.html', pageName: 'addYammerUsers', resolve: {resolveData: defaultResolver}})
    .when('/TMS/ManageUsers/importXls', {templateUrl: 'pages/users/xls/xls.html', pageName: 'importXls', reloadOnSearch: false, resolve: {resolveData: defaultResolver}})
    .when('/TMS/ManageUsers', {templateUrl: 'pages/users/manageUsers.html', pageName: 'manageUsers', controller: 'ManageUsersCtrl', resolve: {resolveData: usersResolver}})

    .when('/TMS/ManageGroups', {templateUrl: 'pages/group/manageGroups.html', pageName: 'manageGroups', controller: 'ManageGroupsCtrl', resolve: {resolveData: groupsResolver}})
    .when('/TMS/ManageGroups/CreateGroup', {templateUrl: 'pages/group/createNewGroup.html', pageName: 'createNewGroup', controller: 'CreateNewGroupCtrl', resolve: {resolveData: createGroupResolver}})

    .when('/TMS/customFields', {templateUrl: 'pages/account/manageCustomFields.html', pageName: 'manageCustomFields', controller: 'ManageCustomFieldsCtrl', resolve: {resolveData: customFieldsResolver}})

    .when('/getStarted', {templateUrl: 'pages/getStarted2/index.html', controller: 'GetStarted2Ctrl', header: false, footer: false, pageColor: '#fff'})
    .when('/getStartedCreate', {templateUrl: 'pages/getStarted3/createPage/index.html', controller: 'CreatePageCtrl', header: false, footer: false, pageColor: '#fff'})
    .when('/getStartedDistribute', {templateUrl: 'pages/getStarted3/distributePage/index.html', controller: 'DistributePageCtrl', header: false, footer: false, pageColor: '#fff'})
    .when('/getStartedTrack', {templateUrl: 'pages/getStarted3/trackPage/index.html', controller: 'TrackPageCtrl', header: false, footer: false, pageColor: '#fff'})
    .when('/getStartedCongrats', {templateUrl: 'pages/getStarted/congrats.html', controller: 'GetStartedCongratsCtrl', header: '/Trainer/pages/getStarted/header.html', pageColor: '#d8eff8', resolve: {resolveData: defaultResolver}})
    .when('/getStartedYammer', {templateUrl: 'pages/getStarted/yammer.html', controller: 'GetStartedYammerCtrl', reloadOnSearch: false, header: false, footer: false, pageColor: '#d8eff8', resolve: {resolveData: defaultResolver}})

    .when('/TMS/Catalog/:catalogId', {templateUrl: 'pages/catalog/catalog.html', pageName: 'catalog', controller: 'CatalogCtrl', resolve: {resolveData: catalogResolver}})
    .when('/TMS/Catalog/:catalogId/addContent', {templateUrl: 'pages/catalog/addCatalogContent.html', pageName: 'addContentToCatalog', controller: 'AddCatalogContentCtrl', resolve: {resolveData: catalogResolver}})

    .when('/TMS/Shopify', {templateUrl: 'pages/shopify/manageShopifyCourses.html', pageName: 'manageShopifyCourses', controller: 'ManageShopifyCoursesCtrl', resolve: {resolveData: shopifyResolver}})
    .when('/TMS/Shopify/addShopifyContent', {templateUrl: 'pages/shopify/addShopifyCourses.html', pageName: 'addShopifyCourses', controller: 'AddShopifyCoursesCtrl', resolve: {resolveData: shopifyResolver}})

    .when('/TMS/Branding', {templateUrl: 'pages/branding/brand.html', pageName: 'branding', controller: 'BrandCtrl', resolve: {resolveData: brandResolver}})

    .when('/Features', {templateUrl: 'pages/features/features.html', pageName: 'features', controller: 'FeaturesCtrl', resolve: { resolveData: featuresResolver}})

    .when('/testError', {template: '<div>Error Page</div>', controller: function () {
      var test = a.b.c;
      /*easy as 1,2,3*/
    }})
    .when('/', { header: showFrame, footer: showFrame, redirectTo: mfConfig.defaultRoute})
    .otherwise({
      flex: true,
      footer: false,
      resolve: {resolveData: seriesResolver}
    });

}]).run(['urlHelper', '$rootScope', 'refreshSession', 'Auth', 'accountFeatures', '$window', '$route', function (urlHelper, $rootScope, refreshSession, Auth, accountFeatures, $window, $route) {
  $rootScope.sessionId = mfConfig.sessionId;
  $rootScope.mfConfig = mfConfig;
  $rootScope.enableNormalNav = true;

  if(!mfConfig || mfConfig.sessionId <= 0) {
    var sessId = urlHelper.getUrlVars()["sessionID"];
    if(sessId && (!$window.document || !$window.document.cookie)) {
      $window.location = '/?sessionID=' + sessId;
    } else {
      $window.location = '/';
    }

    return;
  }

  showTrackingIfFirstTime();
  opzInit($route);
  refreshSession.refresh({
    ignoreInactiveAccount: true
  });

  function showTrackingIfFirstTime() {
    if (mfConfig.showMarketingScripts) {
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer',mfConfig.marketingTagId);

      setTimeout(function () {        //mf.com optimizely tracking
        $('body').append('<iframe name="conversionScripts" class="hideOffscreen" src="/TrainerGS/MarketingConversionScripts.aspx"></iframe>');
      }, 1);

    }
  }

  function opzInit($route) {
    if (!mfConfig.optimizely) return;

    mfConfig.$route = $route;
    mfConfig.replaceRoute = function(oldRoute, newRoute) {
      _.extend($route.routes[oldRoute], _.omit($route.routes[newRoute], 'originalPath', 'regexp'));
    };
    mfConfig.redirectRoute = function(oldPath, newPath) {
      var rt = $route.routes[oldPath];
      delete rt.controller;
      delete rt.templateUrl;
      delete rt.resolve;
      rt.redirectTo = newPath;
    };

    if (!window.optimizely)
      return _kmq.push(['record', 'Optimizely Init Failed']);

    if (mfConfig.defaultRoute === '/getStarted')
      opzActivateTest(mfConfig.optimizely.getStarted);

  }

  function opzActivateTest(testId) {
    if (!window.optimizely)
      return _kmq.push(['record', 'Optimizely Init Failed '+ testId]);

    optimizely.push(["activate", testId]);
    if (!optimizely.data || !optimizely.data.state)
      return _kmq.push(['record', 'Optimizely Activate Failed ' + testId]);

    //_kmq.push(['record', 'Activate Test', {'Opz Prod GetStarted 1-12-2015': optimizely.data.state.variationNamesMap[testId]}]);
  }
}]);

window.loadScriptAsync = function (src) {
  (function () {
    var scrpt = document.createElement('script');
    scrpt.type = 'text/javascript';
    scrpt.async = true;
    scrpt.src = 'https://' + src;
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(scrpt, s);
  })();
};

// Error handling for js errors
angular.module('trainerWebApp').factory('stacktraceService',
  function () {
    // 'printStackTrace' is a global object
    return({
      print: printStackTrace
    });
  }
);

angular.module('trainerWebApp').provider('$exceptionHandler', {
    $get: ['errorLogService', function (errorLogService) {
      return( errorLogService );
    }]
  }
);

angular.module('trainerWebApp').factory('errorLogService',
  ['$log', '$window', 'stacktraceService', '$injector', function ($log, $window, stacktraceService, $injector) {
    function log(exception, cause) {

      $log.error.apply($log, arguments);

      try {
        var errorMessage = exception.toString();

        if (shouldIgnore(errorMessage))
          return;

        var stackTrace = stacktraceService.print({ e: exception }) || [];
        var rootScope = $injector.get('$rootScope') || {};
        var $http = $injector.get('$http') || {};

        // There is a defect in IE 9/10/11 that will not allow
        // you to enter text into a parentless node. Not sure what
        // directive is causing this since gettext is not part of
        // this project
        if (errorMessage && errorMessage == 'Error: Invalid argument.') {
          return;
        }

        // There is a defect in IE 9/10/11 that will not allow
        // you to enter text into a parentless node. Not sure what
        // directive is causing this since gettext is not part of
        // this project
        if (errorMessage && errorMessage == 'Error: Invalid argument.') {
          return;
        }

        var stack = stackTrace.join('\n');
        var data = {
          message: errorMessage || '',
          stack: stack,
          application: 'trainerWeb',
          addInfo: {
            userAgent: navigator.userAgent,
            url: $window.location.href
          }
        };

        if ($http.post) {
          $http.post('/gaviota-api/log', data, angular.noop, angular.noop);
        }
      }
      catch (loggingError) {
        // For Developers - log the log-failure.
        $log.warn("Error logging failed");
        $log.log(loggingError);
      }
    }

    function shouldIgnore(errorMessage) {
      if (!errorMessage) return false;

      if (errorMessage.indexOf('Error: ') == 0)
        errorMessage = errorMessage.substr(7);

      // There is a defect in IE 9/10/11 that will not allow
      // you to enter text into a parentless node. But if we
      // remove the transclusion in getttext this can be removed.
      var invalidArgumentErrors = [
        'Invalid argument.',
        'Argument non valide.',
        'Ungültiges Argument.',
        '参数无效。',
        'Argomento non valido.',
        'Ongeldig argument.',
        'Ogiltigt argument.',
        'Argumento no válido',
        'Недопустимый аргумент.',
        '引数が無効です。',
        '잘못된 인수입니다.',
        'Argumento inválido.',
        'Ugyldig argument.',
        '不正確的引數。',
        'Schnittstelle nicht unterstützt',
        'Ugyldigt argument.',
        'Argumentin arvo ei kelpaa.'
      ]

      if (~invalidArgumentErrors.indexOf(errorMessage))
        return true;

      return false;
    }

    // Return the logging function.
    return( log );
  }]
);
